<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="passwordOffcanvas" data-bs-backdrop="static" aria-labelledby="passwordOffcanvasLabel">
    <div class="offcanvas-header">
      <button class="btn-back" id="closeBtn" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close" @click="doCancel()">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" id="passwordOffcanvasLabel">
        {{ $t('user.changePassword') }}
      </h5>
    </div>
    <vee-form v-slot="{ handleSubmit }" as="div" ref="externalChangePasswordForm">
      <form @submit.prevent.stop="handleSubmit(changePassword)">
        <div class="offcanvas-body">
          <div class="form-floating">
            <vee-field name="currentPassword" v-model="currentPassword" rules="required" v-slot="{ field, errorMessage }">
              <input v-bind="field" type="password" class="form-control" ref="currentPassword" id="currentPassword" :placeholder="$t('user.currentPassword')" :disabled="disabled" data-test="inputCurrentPassword">
              <span class="vee-error">{{ errorMessage }}</span>
            </vee-field>
            <label for="currentPassword">{{ $t('user.currentPassword') }}</label>
          </div>
          <div class="form-floating">
            <vee-field name="newPassword" v-model="newPassword" rules="required|min:8" v-slot="{ field, errorMessage }">
              <input v-bind="field"
                     :type="showNewPassword ? 'text' : 'password'"
                     class="form-control"
                     id="newPassword"
                     ref="newPassword"
                     :placeholder="$t('user.newPassword')"
                     :disabled="disabled"
                     data-test="inputNewPassword"
                     @keyup="checkPassword(newPassword)">
               <button class="no-btn" type="button" name="button" data-test="btnShowNewPassword" @click="showNewPassword = !showNewPassword">
                 <i class="fa" :class="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
               </button>
              <small class="strength-password" :class="strengthInfo" v-show="strengthInfo">{{ strengthInfo ? $t(`strengthPassword.${strengthInfo}`) : "" }}</small>
              <span class="vee-error">{{ errorMessage ? errorMessage : $t(`${strengthPasswordMessage}`) }}</span>
              <!-- <span class="vee-error">{{ errorMessage }}</span> -->
            </vee-field>
            <label for="newPassword">{{ $t('user.newPassword') }}</label>
          </div>
          <div class="form-floating">
            <vee-field name="confirmPassword" v-model="passwordConfirmation" rules="required|confirmed:newPassword" v-slot="{ field, errorMessage }">
              <input v-bind="field" :type="showConfirmNewPassword ? 'text' : 'password'" class="form-control" id="passwordConfirmation" :placeholder="$t('user.passwordConfirmation')" :disabled="disabled" data-test="inputConfirmPassword">
              <button class="no-btn" type="button" name="button" data-test="btnShowConfirmPassword" @click="showConfirmNewPassword = !showConfirmNewPassword">
                  <i class="fa" :class="showConfirmNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
              <span class="vee-error">{{ errorMessage }}</span>
            </vee-field>
            <label for="passwordConfirmation">{{ $t('user.passwordConfirmation') }}</label>
          </div>

          <div class="offcanvas-footer">
            <button type="submit" class="btn btn-success" data-test="btnModifyConfirm">{{ $t('user.modify') }}</button>
          </div>
        </div>
      </form>
    </vee-form>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  .offcanvas-header,
  .offcanvas-body {
    padding:                            0;
  }

  .offcanvas-header {
    display:                            block;
  }

  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-body {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    p,
    a {
      color:                            var(--Brand-Primary, #1B294A);
      font-size:                        var(--font-size-14);
      font-weight:                      300;
      line-height:                      140%; /* 19.6px */
      margin:                           0;
    }
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      // gap:                              10px;
      // flex:                             1 0 0;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
      // margin-top:                       26px;
    }
  }

  .vee-error {
    width:                              100% !important;
  }
}
</style>

<script>
import { useExternalStore } from '@/store/external'

export default {
  name: 'ExternalPatientChangePasswordOffcanvas',
  data: () => ({
    alert: {
      message: null,
      class: null
    },
    patientEmail: "",
    currentPassword: "",
    newPassword: "",
    passwordConfirmation: "",
    disabled: false,
    offcanvas_password: null,
    resolvePromise: null,
    rejectPromise: null,
    strengthPasswordMessage: 'zxcvbnMessages.default',
    strengthInfo: null,
    account: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      pin: "",
    },
    showNewPassword: false,
    showConfirmNewPassword: false,
  }),
  mounted() {
  },
  methods: {
    show(options = {}) {
      const externalStore = useExternalStore()

      console.log('externalStore.sessionInfo.user', externalStore.sessionInfo);

      if (externalStore) {
        this.account.firstName = externalStore.sessionInfo.patient.firstName
        this.account.lastName = externalStore.sessionInfo.patient.lastName
        this.account.email = externalStore.sessionInfo.patient.email
      }

      this.offcanvas_password = new bootstrap.Offcanvas(document.getElementById('passwordOffcanvas'))
      this.offcanvas_password.show();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      if (this.resolvePromise) {
        this.resolvePromise(true);
      }

      this.offcanvas_password.hide();
      this.resetForm();
    },

    doCancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false);
      }

      this.offcanvas_password.hide();
      this.resetForm();
    },

    async changePassword() {

      try {
        let paramsAccount = {
          account: this.account,
        }
        let responseValidate = await this.$utils.validatePassword(paramsAccount.account)

        if (responseValidate.valid == false){
          console.log("errror")
          this.$message.popup(this, 'zxcvbnMessages.error', 'operationFail', 'error')
          return
        }

        NProgress.start()
        const params = {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        }
        let result = await this.$externalService.changePassword(params)

        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')

        this.doConfirm()
      } catch(err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.updatedError', 'danger')
      } finally {
        NProgress.done(true);
        // this.disabled = false;
      }
    },

    resetForm() {
      this.$refs.externalChangePasswordForm.resetForm();
    },

    async checkPassword(password) {

      this.account.password = password

      let params = {
        account: this.account
      }

      let isValidPassword = await this.$utils.validatePassword(params.account)

      switch (isValidPassword.score) {
        case 0:
        case 1:
        case 2:
          this.strengthInfo = 'danger'
          break;
        case 3:
          this.strengthInfo = 'warning'
          break;
        case 4:
          this.strengthInfo = 'success'
          break;
      }

      if (isValidPassword.valid) {
        this.strengthPasswordMessage = 'zxcvbnMessages.default'
      } else {
        this.strengthPasswordMessage = isValidPassword.warning ? 'zxcvbnMessages.warnings.' + isValidPassword.warning :
                                                            'zxcvbnMessages.suggestions.' + isValidPassword.suggestion[0]
      }
    },
  },
  beforeUnmount() {
    const offcanvasElement = document.getElementById('passwordOffcanvas');
    if (offcanvasElement) {
      offcanvasElement.removeEventListener('hidden.bs.offcanvas', this.handleOffcanvasHidden);
    }
  }
}
</script>
